import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";

export default function RefLanding() {
  const { code } = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    let vid = localStorage.getItem("ex_visitor_id");
    if (!vid) { vid = `v_${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`; localStorage.setItem("ex_visitor_id", vid); }
    if (code) localStorage.setItem("ex_ref", code.toUpperCase());
    const seenKey = `ex_ref_seen_${(code || "").toUpperCase()}`;
    if (sessionStorage.getItem(seenKey)) { navigate("/quiz", { replace: true }); return; }
    sessionStorage.setItem(seenKey, "1");
    api.post("/ref/visit", { code: code || "", visitor_id: vid }).catch(() => {}).finally(() => navigate("/quiz", { replace: true }));
  }, [code, navigate]);
  return <div data-testid="ref-landing" className="min-h-screen bg-exodus-bg" />;
}
